//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

import { IContextualMenuItem } from "@fluentui/react";
import { IBrandColors, SpacingKey } from "cayo.ui";
import { LogicalOperator } from "@cayo/shared/api/types/cayo-graph";
import {
  IJsonForm,
  FontSize,
  FontWeight,
  IUIItem,
  ILayoutItem,
  Align,
  BorderType,
  IIcon,
  IAjaxAction,
  IButton,
  IValidationErrors,
  IPossibleValue,
  IColumn,
  ComparisonOperator,
  IFormField,
  IDetailsList,
  IActionButton,
  ActionParameters,
  ContextualMenuItemType,
  IObjectPickerModalOptions,
  IDropdownOption,
  IScope,
  ISearchScope,
  IScheme,
  OverlayIcon,
  INavLink,
} from "@cayo/shared/api/types/schema";
import { throwException } from "@cayo/shared/api/utils/throwException";

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ActionClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  get(id: string): Promise<IJsonForm | null> {
    let url_ = this.baseUrl + "/scheme/action/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGet(_response);
    });
  }

  protected processGet(response: Response): Promise<IJsonForm | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as IJsonForm);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<IJsonForm | null>(null as any);
  }
}

export class ThemeClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  getTheme(name: string): Promise<ITheme | null> {
    let url_ = this.baseUrl + "/themes/{name}";
    if (name === undefined || name === null)
      throw new Error("The parameter 'name' must be defined.");
    url_ = url_.replace("{name}", encodeURIComponent("" + name));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetTheme(_response);
    });
  }

  protected processGetTheme(response: Response): Promise<ITheme | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ITheme);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ITheme | null>(null as any);
  }

  getThemes(): Promise<ITheme | null> {
    let url_ = this.baseUrl + "/themes";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetThemes(_response);
    });
  }

  protected processGetThemes(response: Response): Promise<ITheme | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ITheme);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ITheme | null>(null as any);
  }
}

export interface IDateTimeRange {
  disabled?: boolean | undefined;
  required?: boolean | undefined;
  hideWhenEmpty?: boolean | undefined;
  readOnly?: boolean | undefined;
  label?: string | undefined;
  tooltip?: string | undefined;
  placeHolder?: string | undefined;
  defaultValue?: string | undefined;
  shortName?: string | undefined;
  autoFocus?: boolean | undefined;
  hideRequiredAsterix?: boolean | undefined;
  hideCopyButton?: boolean | undefined;
  valueDependsOn?: string | undefined;
  isConfidential?: boolean | undefined;
  isPicker?: boolean | undefined;
  order?: number | undefined;
  collapseIfDisabled?: boolean | undefined;
  visible?: boolean | undefined;
  errors?: IValidationErrors | undefined;
  dataType?: string | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  predefinedRanges?: IPredefinedRange[] | undefined;
  predefinedRange?: string | undefined;
  begin?: Date | undefined;
  end?: Date | undefined;
}

export interface IPredefinedRange {
  name?: string | undefined;
  value?: string | undefined;
}

export interface ITextField {
  formatter?: Formatters | undefined;
  nullValueDecorator?: string | undefined;
  disabled?: boolean | undefined;
  required?: boolean | undefined;
  hideWhenEmpty?: boolean | undefined;
  readOnly?: boolean | undefined;
  label?: string | undefined;
  tooltip?: string | undefined;
  placeHolder?: string | undefined;
  defaultValue?: string | undefined;
  shortName?: string | undefined;
  autoFocus?: boolean | undefined;
  hideRequiredAsterix?: boolean | undefined;
  hideCopyButton?: boolean | undefined;
  valueDependsOn?: string | undefined;
  isConfidential?: boolean | undefined;
  isPicker?: boolean | undefined;
  order?: number | undefined;
  collapseIfDisabled?: boolean | undefined;
  visible?: boolean | undefined;
  errors?: IValidationErrors | undefined;
  dataType?: string | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  value?: string | undefined;
  pattern?: string | undefined;
  multiline?: boolean | undefined;
  hidden?: boolean | undefined;
  errorMessage?: string | undefined;
  autocomplete?: Autocomplete | undefined;
  isMultiline?: boolean | undefined;
  copyEnabled?: boolean | undefined;
}

export type Formatters = "fileSize" | "duration" | "relativetime" | "fileTime" | "dateTime";

export type Autocomplete = "off" | "on" | "username" | "new-password" | "current-password";

export interface ICheckbox {
  disabled?: boolean | undefined;
  required?: boolean | undefined;
  hideWhenEmpty?: boolean | undefined;
  readOnly?: boolean | undefined;
  label?: string | undefined;
  tooltip?: string | undefined;
  placeHolder?: string | undefined;
  defaultValue?: string | undefined;
  shortName?: string | undefined;
  autoFocus?: boolean | undefined;
  hideRequiredAsterix?: boolean | undefined;
  hideCopyButton?: boolean | undefined;
  valueDependsOn?: string | undefined;
  isConfidential?: boolean | undefined;
  isPicker?: boolean | undefined;
  order?: number | undefined;
  collapseIfDisabled?: boolean | undefined;
  visible?: boolean | undefined;
  errors?: IValidationErrors | undefined;
  dataType?: string | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  value: boolean;
  onText?: string | undefined;
  offText?: string | undefined;
  checked?: boolean | undefined;
}

export interface IDropDown {
  formatter?: Formatters | undefined;
  nullValueDecorator?: string | undefined;
  disabled?: boolean | undefined;
  required?: boolean | undefined;
  hideWhenEmpty?: boolean | undefined;
  readOnly?: boolean | undefined;
  label?: string | undefined;
  tooltip?: string | undefined;
  placeHolder?: string | undefined;
  defaultValue?: string | undefined;
  shortName?: string | undefined;
  autoFocus?: boolean | undefined;
  hideRequiredAsterix?: boolean | undefined;
  hideCopyButton?: boolean | undefined;
  valueDependsOn?: string | undefined;
  isConfidential?: boolean | undefined;
  isPicker?: boolean | undefined;
  order?: number | undefined;
  collapseIfDisabled?: boolean | undefined;
  visible?: boolean | undefined;
  errors?: IValidationErrors | undefined;
  dataType?: string | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  options: IDropdownOption[];
  value?: any | undefined;
  selectedKey?: string;
  formatValue?: string;
  note?: string;
}

type DependencyKeysTypes = "nestedType";

export type DepsType = { dependentKey: string; dependencyKey: string; deps: string[] };

export type IFilterDependency = {
  [key in DependencyKeysTypes]: DepsType;
};

export interface IObjectPicker {
  title: string;
  disabled?: boolean | undefined;
  required?: boolean | undefined;
  hideWhenEmpty?: boolean | undefined;
  readOnly?: boolean | undefined;
  hidden?: boolean | undefined;
  renderInput?: boolean | undefined;
  label?: string | undefined;
  tooltip?: string | undefined;
  placeHolder?: string | undefined;
  defaultValue?: string | undefined;
  shortName?: string | undefined;
  autoFocus?: boolean | undefined;
  hideRequiredAsterix?: boolean | undefined;
  hideCopyButton?: boolean | undefined;
  valueDependsOn?: string | undefined;
  isConfidential?: boolean | undefined;
  isPicker?: boolean | undefined;
  dependsFrom?: string | undefined;
  order?: number | undefined;
  collapseIfDisabled?: boolean | undefined;
  visible?: boolean | undefined;
  errors?: IValidationErrors | undefined;
  dataType?: string | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  path?: string | undefined;
  queryPath: string;
  scope?: IScope | undefined;
  searchScopes?: ISearchScope[] | undefined;
  filter?: string | undefined;
  body?: any;
  expand?: string | undefined;
  columns: IColumn[] | undefined;
  multiselect?: boolean | undefined;
  maxItems?: number | undefined;
  selectPropertyName?: string | undefined;
  displayNameProp?: string | undefined;
  displayNameAlternateProp?: string | undefined;
  modalOptions: IObjectPickerModalOptions;
  defaultOrder?: string[] | undefined;
  logicalOperator?: LogicalOperator;
  compareOperator?: ComparisonOperator;
  isExclude?: string;
  modelProperty?: string;
  valueTemplate?: string | object;
  clientBehavior?: IQueryPickerClientBehavior;
  queryOperator?: string | undefined;
}

export interface IQueryPickerClientBehavior {
  cacheSearchResponse?: boolean;
  clientSideSearch?: boolean;
}

export interface ILookupResultItem {
  id: string;
  lookupObjs: any[];
  "lookupObjs@odata.type": string;
  tagName: string;
}

export interface IMultiValue {
  disabled?: boolean | undefined;
  required?: boolean | undefined;
  hideWhenEmpty?: boolean | undefined;
  readOnly?: boolean | undefined;
  label?: string | undefined;
  tooltip?: string | undefined;
  placeHolder?: string | undefined;
  defaultValue?: string | undefined;
  shortName?: string | undefined;
  autoFocus?: boolean | undefined;
  hideRequiredAsterix?: boolean | undefined;
  hideCopyButton?: boolean | undefined;
  valueDependsOn?: string | undefined;
  isConfidential?: boolean | undefined;
  isPicker?: boolean | undefined;
  order?: number | undefined;
  collapseIfDisabled?: boolean | undefined;
  visible?: boolean | undefined;
  errors?: IValidationErrors | undefined;
  dataType?: string | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  pattern?: string | undefined;
  value?: any[] | undefined;
  addButtonTitle?: string | undefined;
}

export interface ISubmitButton {
  text?: string | undefined;
  icon?: IIcon | undefined;
  image?: string | undefined;
  iconAtRight?: boolean | undefined;
  permittedRole?: string | undefined;
  action?: string | undefined;
  ajaxAction?: IAjaxAction | undefined;
  theme?: string | undefined;
  disabled?: boolean | undefined;
  required?: boolean | undefined;
  hideWhenEmpty?: boolean | undefined;
  readOnly?: boolean | undefined;
  label?: string | undefined;
  tooltip?: string | undefined;
  placeHolder?: string | undefined;
  defaultValue?: string | undefined;
  shortName?: string | undefined;
  autoFocus?: boolean | undefined;
  hideRequiredAsterix?: boolean | undefined;
  hideCopyButton?: boolean | undefined;
  valueDependsOn?: string | undefined;
  isConfidential?: boolean | undefined;
  isPicker?: boolean | undefined;
  order?: number | undefined;
  collapseIfDisabled?: boolean | undefined;
  visible?: boolean | undefined;
  errors?: IValidationErrors | undefined;
  dataType?: string | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
}

export interface IResetButton {
  text?: string | undefined;
  icon?: IIcon | undefined;
  image?: string | undefined;
  iconAtRight?: boolean | undefined;
  permittedRole?: string | undefined;
  action?: string | undefined;
  ajaxAction?: IAjaxAction | undefined;
  theme?: string | undefined;
  disabled?: boolean | undefined;
  required?: boolean | undefined;
  hideWhenEmpty?: boolean | undefined;
  readOnly?: boolean | undefined;
  label?: string | undefined;
  tooltip?: string | undefined;
  placeHolder?: string | undefined;
  defaultValue?: string | undefined;
  shortName?: string | undefined;
  autoFocus?: boolean | undefined;
  hideRequiredAsterix?: boolean | undefined;
  hideCopyButton?: boolean | undefined;
  valueDependsOn?: string | undefined;
  isConfidential?: boolean | undefined;
  isPicker?: boolean | undefined;
  order?: number | undefined;
  collapseIfDisabled?: boolean | undefined;
  visible?: boolean | undefined;
  errors?: IValidationErrors | undefined;
  dataType?: string | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
}

export interface ICommandBarButton {
  text?: string | undefined;
  icon?: IIcon | undefined;
  image?: string | undefined;
  iconAtRight?: boolean | undefined;
  permittedRole?: string | undefined;
  action?: string | undefined;
  ajaxAction?: IAjaxAction | undefined;
  theme?: string | undefined;
  disabled?: boolean | undefined;
  required?: boolean | undefined;
  hideWhenEmpty?: boolean | undefined;
  readOnly?: boolean | undefined;
  label?: string | undefined;
  tooltip?: string | undefined;
  placeHolder?: string | undefined;
  defaultValue?: string | undefined;
  shortName?: string | undefined;
  autoFocus?: boolean | undefined;
  hideRequiredAsterix?: boolean | undefined;
  hideCopyButton?: boolean | undefined;
  valueDependsOn?: string | undefined;
  isConfidential?: boolean | undefined;
  isPicker?: boolean | undefined;
  order?: number | undefined;
  collapseIfDisabled?: boolean | undefined;
  visible?: boolean | undefined;
  errors?: IValidationErrors | undefined;
  dataType?: string | undefined;
  type: string;
  id?: string | undefined;
  key?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  actions?: IActionItem[] | undefined;
  overlayIcon?: OverlayIcon | undefined;
  itemType?: ContextualMenuItemType | undefined;
}

export interface IActionItem {
  action?: string | undefined;
  text?: string | undefined;
}

export interface IRunnableButton {
  text?: string | undefined;
  icon?: IIcon | undefined;
  image?: string | undefined;
  iconAtRight?: boolean | undefined;
  permittedRole?: string | undefined;
  action?: string | undefined;
  ajaxAction?: IAjaxAction | undefined;
  theme?: string | undefined;
  disabled?: boolean | undefined;
  required?: boolean | undefined;
  hideWhenEmpty?: boolean | undefined;
  readOnly?: boolean | undefined;
  label?: string | undefined;
  tooltip?: string | undefined;
  placeHolder?: string | undefined;
  defaultValue?: string | undefined;
  shortName?: string | undefined;
  autoFocus?: boolean | undefined;
  hideRequiredAsterix?: boolean | undefined;
  hideCopyButton?: boolean | undefined;
  valueDependsOn?: string | undefined;
  isConfidential?: boolean | undefined;
  isPicker?: boolean | undefined;
  order?: number | undefined;
  collapseIfDisabled?: boolean | undefined;
  visible?: boolean | undefined;
  errors?: IValidationErrors | undefined;
  dataType?: string | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  url: string;
  stateProp: string;
  runStateValue: string;
  loadingText?: string | undefined;
}

export interface ILink {
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  title?: string | undefined;
  href?: string | undefined;
}

export interface IText {
  formatter?: Formatters | undefined;
  nullValueDecorator?: string | undefined;
  disabled?: boolean | undefined;
  required?: boolean | undefined;
  hideWhenEmpty?: boolean | undefined;
  readOnly?: boolean | undefined;
  label?: string | undefined;
  tooltip?: string | undefined;
  placeHolder?: string | undefined;
  defaultValue?: string | undefined;
  shortName?: string | undefined;
  autoFocus?: boolean | undefined;
  hideRequiredAsterix?: boolean | undefined;
  hideCopyButton?: boolean | undefined;
  valueDependsOn?: string | undefined;
  isConfidential?: boolean | undefined;
  isPicker?: boolean | undefined;
  order?: number | undefined;
  collapseIfDisabled?: boolean | undefined;
  visible?: boolean | undefined;
  errors?: IValidationErrors | undefined;
  dataType?: string | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  block: boolean;
  value?: any | undefined;
  nowrap?: boolean | undefined;
}

export interface IImage {
  roundBorder?: boolean | undefined;
  width?: number | undefined;
  height?: number | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  url?: string | undefined;
  fallbackIcon?: IIcon | undefined;
}

export interface ILineChart {
  nameKey: string;
  showLegend?: boolean | undefined;
  colors?: string[] | undefined;
  noItemsMessage?: string | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  leftDataKeys: string[];
  rightDataKeys?: string[] | undefined;
  leftYLabel: string;
  rightYLabel?: string | undefined;
  chartType?: LineChartType | undefined;
}

export type LineChartType = "line" | "stacked";

export interface IWidget {
  items?: IUIItem[] | undefined;
  layout?: ILayoutItem[] | undefined;
  userRoles?: string[] | undefined;
  version?: number | undefined;
  stretch?: boolean | undefined;
  childrenGap?: number | undefined;
  justifyContent?: Align | undefined;
  valign?: boolean | undefined;
  border?: BorderType | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  title: string;
  hideHeader?: boolean | undefined;
  titleSeparator?: boolean | undefined;
  stick?: Stick | undefined;
  showClock?: boolean | undefined;
  galleryImage?: IIcon | undefined;
  noLicenseMessage?: string | undefined;
  help?: IHelpInfo | undefined;
}

export interface IRowLayout {
  items?: string[] | undefined;
  sizes?: string[] | undefined;
  stretch?: boolean | undefined;
  childrenGap?: number | undefined;
  justifyContent?: Align | undefined;
  valign?: boolean | undefined;
  verticalAlign?: Align;
  border?: BorderType | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
}

export interface ITabLayout {
  name: string;
  items: ITabLayoutItem[];
  bindings?: { [key: string]: string } | undefined;
}
export interface ITabLayoutItem {
  title: string;
  items: string[];
}

export interface IPieChart {
  nameKey: string;
  showLegend?: boolean | undefined;
  colors?: string[] | undefined;
  noItemsMessage?: string | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  valueKey: string;
  labelPosition?: LabelPosition | undefined;
  showTotal?: boolean | undefined;
}

export type LabelPosition = "bottom" | "left";

export interface ITimeSeries {
  url: string;
  propertyPath?: string | undefined;
  noItemsMessage?: string | undefined;
  noItemsTemplate?: IUIItem | undefined;
  title: string;
  hideHeader?: boolean | undefined;
  titleSeparator?: boolean | undefined;
  stick?: Stick | undefined;
  showClock?: boolean | undefined;
  galleryImage?: IIcon | undefined;
  noLicenseMessage?: string | undefined;
  help?: IHelpInfo | undefined;
  items?: IUIItem[] | undefined;
  layout?: ILayoutItem[] | undefined;
  userRoles?: string[] | undefined;
  version?: number | undefined;
  stretch?: boolean | undefined;
  childrenGap?: number | undefined;
  justifyContent?: Align | undefined;
  valign?: boolean | undefined;
  border?: BorderType | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  lineChart: ILineChart;
  periodOptions: IDropdownOption[];
  runButton?: IButton | undefined;
  viewAllTitle?: string | undefined;
}

export type Stick = "top" | "right" | "bottom" | "left";

export interface IHelpInfo {
  link?: string | undefined;
  title?: string | undefined;
}

export interface IProtectedObjects {
  url: string;
  propertyPath?: string | undefined;
  noItemsMessage?: string | undefined;
  noItemsTemplate?: IUIItem | undefined;
  title: string;
  hideHeader?: boolean | undefined;
  titleSeparator?: boolean | undefined;
  stick?: Stick | undefined;
  showClock?: boolean | undefined;
  galleryImage?: IIcon | undefined;
  noLicenseMessage?: string | undefined;
  help?: IHelpInfo | undefined;
  items?: IUIItem[] | undefined;
  layout?: ILayoutItem[] | undefined;
  userRoles?: string[] | undefined;
  version?: number | undefined;
  stretch?: boolean | undefined;
  childrenGap?: number | undefined;
  justifyContent?: Align | undefined;
  valign?: boolean | undefined;
  border?: BorderType | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  chart: IPieChart;
}

export interface IActivity {
  title: string;
  hideHeader?: boolean | undefined;
  titleSeparator?: boolean | undefined;
  stick?: Stick | undefined;
  showClock?: boolean | undefined;
  galleryImage?: IIcon | undefined;
  noLicenseMessage?: string | undefined;
  help?: IHelpInfo | undefined;
  items?: IUIItem[] | undefined;
  layout?: ILayoutItem[] | undefined;
  userRoles?: string[] | undefined;
  version?: number | undefined;
  stretch?: boolean | undefined;
  childrenGap?: number | undefined;
  justifyContent?: Align | undefined;
  valign?: boolean | undefined;
  border?: BorderType | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
}

export interface ICounterSeries {
  nameKey: string;
  showLegend?: boolean | undefined;
  colors?: string[] | undefined;
  noItemsMessage?: string | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  valueKey?: string | undefined;
  dataKeys?: string[] | undefined;
}

export interface ICounter {
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  label?: string | undefined;
  data?: number | undefined;
  labelColor?: string | undefined;
  dataColor?: string | undefined;
  linearIndicator?: ILinearIndicator | undefined;
}

export interface ILinearIndicator {
  color?: string | undefined;
  horizontal?: boolean | undefined;
}

export interface IBasicList {
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  url?: string | undefined;
  propertyPath?: string | undefined;
  itemTemplate?: IUIItem | undefined;
  noItemsTemplate?: IUIItem | undefined;
  noItemsMessage?: string | undefined;
  moreItemsText?: string | undefined;
  moreAction?: string | undefined;
  notificationSource?: string | undefined;
  footer?: IScheme | undefined;
}

export interface IActivityItem {
  stretch?: boolean | undefined;
  childrenGap?: number | undefined;
  justifyContent?: Align | undefined;
  valign?: boolean | undefined;
  border?: BorderType | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  title?: string | undefined;
  icon?: IGraphicsItem | undefined;
  descriptions?: string[] | undefined;
}

export interface IGraphicsItem {
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  roundBorder?: boolean | undefined;
  width?: number | undefined;
  height?: number | undefined;
}

export interface IEmptyItem {
  stretch?: boolean | undefined;
  childrenGap?: number | undefined;
  justifyContent?: Align | undefined;
  valign?: boolean | undefined;
  border?: BorderType | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  title?: string | undefined;
  addButton?: IButton | undefined;
}

export interface IFacts {
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  url?: string | undefined;
  items?: IFact[] | undefined;
}

export interface IFact {
  name?: string | undefined;
  value?: string | undefined;
}

export interface IHtml {
  disabled?: boolean | undefined;
  required?: boolean | undefined;
  hideWhenEmpty?: boolean | undefined;
  readOnly?: boolean | undefined;
  label?: string | undefined;
  tooltip?: string | undefined;
  placeHolder?: string | undefined;
  defaultValue?: string | undefined;
  shortName?: string | undefined;
  autoFocus?: boolean | undefined;
  hideRequiredAsterix?: boolean | undefined;
  hideCopyButton?: boolean | undefined;
  valueDependsOn?: string | undefined;
  isConfidential?: boolean | undefined;
  isPicker?: boolean | undefined;
  order?: number | undefined;
  collapseIfDisabled?: boolean | undefined;
  visible?: boolean | undefined;
  errors?: IValidationErrors | undefined;
  dataType?: string | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  value?: string | undefined;
}

export interface IObjectLinks {
  disabled?: boolean | undefined;
  required?: boolean | undefined;
  hideWhenEmpty?: boolean | undefined;
  readOnly?: boolean | undefined;
  label?: string | undefined;
  tooltip?: string | undefined;
  placeHolder?: string | undefined;
  defaultValue?: string | undefined;
  shortName?: string | undefined;
  autoFocus?: boolean | undefined;
  hideRequiredAsterix?: boolean | undefined;
  hideCopyButton?: boolean | undefined;
  valueDependsOn?: string | undefined;
  isConfidential?: boolean | undefined;
  isPicker?: boolean | undefined;
  order?: number | undefined;
  collapseIfDisabled?: boolean | undefined;
  visible?: boolean | undefined;
  errors?: IValidationErrors | undefined;
  dataType?: string | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  items?: any[] | undefined;
  formatter?: Formatters | undefined;
  nullValueDecorator?: string | undefined;
}

export interface ICallout {
  items?: IUIItem[] | undefined;
  layout?: ILayoutItem[] | undefined;
  userRoles?: string[] | undefined;
  version?: number | undefined;
  stretch?: boolean | undefined;
  childrenGap?: number | undefined;
  justifyContent?: Align | undefined;
  valign?: boolean | undefined;
  border?: BorderType | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  title?: string | undefined;
  icon?: IIcon | undefined;
  padding?: SpacingKey[] | undefined;
}

export interface IMultiCheckbox {
  disabled?: boolean | undefined;
  required?: boolean | undefined;
  hideWhenEmpty?: boolean | undefined;
  readOnly?: boolean | undefined;
  label?: string | undefined;
  tooltip?: string | undefined;
  placeHolder?: string | undefined;
  defaultValue?: string | undefined;
  shortName?: string | undefined;
  autoFocus?: boolean | undefined;
  hideRequiredAsterix?: boolean | undefined;
  hideCopyButton?: boolean | undefined;
  valueDependsOn?: string | undefined;
  isConfidential?: boolean | undefined;
  isPicker?: boolean | undefined;
  order?: number | undefined;
  collapseIfDisabled?: boolean | undefined;
  visible?: boolean | undefined;
  errors?: IValidationErrors | undefined;
  dataType?: string | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  possibleValues?: IPossibleValue[] | undefined;
  value?: any[] | undefined;
}

export interface IDateTimeBox {
  disabled?: boolean | undefined;
  required?: boolean | undefined;
  hideWhenEmpty?: boolean | undefined;
  readOnly?: boolean | undefined;
  label?: string | undefined;
  tooltip?: string | undefined;
  placeHolder?: string | undefined;
  defaultValue?: string | undefined;
  shortName?: string | undefined;
  autoFocus?: boolean | undefined;
  hideRequiredAsterix?: boolean | undefined;
  hideCopyButton?: boolean | undefined;
  valueDependsOn?: string | undefined;
  isConfidential?: boolean | undefined;
  isPicker?: boolean | undefined;
  order?: number | undefined;
  collapseIfDisabled?: boolean | undefined;
  visible?: boolean | undefined;
  errors?: IValidationErrors | undefined;
  dataType?: string | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  showDate?: boolean | undefined;
  showTime?: boolean | undefined;
  value?: Date | undefined;
  dateValidation?: IValidation | undefined;
  timeValidation?: IValidation | undefined;
}

export interface IValidation {
  errors?: IValidationErrors | undefined;
  errorMessage?: string | undefined;
}

export interface IPivot {
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  items: IPivotItem[];
  verticalOrientation?: boolean | undefined;
}

export interface IPivotItem {
  headerText: string;
  schemePath: string;
  customView?: string | undefined;
  parameters?: string | undefined;
  readOnly?: boolean | undefined;
  order: number;
}

export interface IObjectTitle {
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  titleProperty?: string | undefined;
  description?: string | undefined;
  isTitleReadonly?: boolean | undefined;
  isDescriptionReadonly?: boolean | undefined;
  objectFacts?: string[] | undefined;
  icon?: string;
}

export interface IObjectLink {
  formatter?: Formatters | undefined;
  nullValueDecorator?: string | undefined;
  disabled?: boolean | undefined;
  required?: boolean | undefined;
  hideWhenEmpty?: boolean | undefined;
  readOnly?: boolean | undefined;
  label?: string | undefined;
  tooltip?: string | undefined;
  placeHolder?: string | undefined;
  defaultValue?: string | undefined;
  shortName?: string | undefined;
  autoFocus?: boolean | undefined;
  hideRequiredAsterix?: boolean | undefined;
  hideCopyButton?: boolean | undefined;
  valueDependsOn?: string | undefined;
  isConfidential?: boolean | undefined;
  isPicker?: boolean | undefined;
  isSoftLink?: boolean | undefined;
  order?: number | undefined;
  collapseIfDisabled?: boolean | undefined;
  visible?: boolean | undefined;
  errors?: IValidationErrors | undefined;
  dataType?: string | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  commands?: IActionButton[] | undefined;
}

export interface IDatasetWidget {
  title: string;
  hideHeader?: boolean | undefined;
  titleSeparator?: boolean | undefined;
  stick?: Stick | undefined;
  showClock?: boolean | undefined;
  galleryImage?: IIcon | undefined;
  noLicenseMessage?: string | undefined;
  help?: IHelpInfo | undefined;
  items?: IUIItem[] | undefined;
  layout?: ILayoutItem[] | undefined;
  userRoles?: string[] | undefined;
  version?: number | undefined;
  stretch?: boolean | undefined;
  childrenGap?: number | undefined;
  justifyContent?: Align | undefined;
  valign?: boolean | undefined;
  border?: BorderType | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  url: string;
  propertyPath?: string | undefined;
  noItemsMessage?: string | undefined;
  noItemsTemplate?: IUIItem | undefined;
}

export interface IGauge {
  nameKey: string;
  showLegend?: boolean | undefined;
  colors?: string[] | undefined;
  noItemsMessage?: string | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  dataKeys: string[];
  valueKey: string;
}

export interface IODataWidget {
  title: string;
  hideHeader?: boolean | undefined;
  titleSeparator?: boolean | undefined;
  stick?: Stick | undefined;
  showClock?: boolean | undefined;
  galleryImage?: IIcon | undefined;
  noLicenseMessage?: string | undefined;
  help?: IHelpInfo | undefined;
  items?: IUIItem[] | undefined;
  layout?: ILayoutItem[] | undefined;
  userRoles?: string[] | undefined;
  version?: number | undefined;
  stretch?: boolean | undefined;
  childrenGap?: number | undefined;
  justifyContent?: Align | undefined;
  valign?: boolean | undefined;
  border?: BorderType | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  scheme?: IContentScheme | undefined;
}

export interface IContentScheme {
  items?: IUIItem[] | undefined;
  layout?: ILayoutItem[] | undefined;
  userRoles?: string[] | undefined;
  version?: number | undefined;
  stretch?: boolean | undefined;
  childrenGap?: number | undefined;
  justifyContent?: Align | undefined;
  valign?: boolean | undefined;
  border?: BorderType | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  targetType?: string | undefined;
  entitySetPath?: string | undefined;
  commandBar?: ICommandBar | undefined;
  filterBar?: IQuickFilterBar | undefined;
  advancedFilterBar?: IFilterBar | undefined;
  detailsList?: IDetailsList | undefined;
  savedQueries?: ISavedQueriesDescription | undefined;
  isSearchSupported?: boolean | undefined;
  title?: string;
}

export interface IPickerScheme extends IContentScheme {
  title: string;
}

export interface ICommandBar {
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  items?: ICommandBarItem[] | undefined;
  farItems?: ICommandBarItem[] | undefined;
  gridInfo?: IBriefGridInfo | undefined;
  showSelectionCounter?: boolean | undefined;
}

export interface ICommandBarItem {
  actions?: IActionItem[] | undefined;
  text?: string | undefined;
  icon?: IIcon | undefined;
  image?: string | undefined;
  iconAtRight?: boolean | undefined;
  permittedRole?: string | undefined;
  action?: string | undefined;
  actionParameters?: ActionParameters;
  ajaxAction?: IAjaxAction | undefined;
  theme?: string | undefined;
  disabled?: boolean | undefined;
  required?: boolean | undefined;
  hideWhenEmpty?: boolean | undefined;
  readOnly?: boolean | undefined;
  label?: string | undefined;
  tooltip?: string | undefined;
  placeHolder?: string | undefined;
  defaultValue?: string | undefined;
  shortName?: string | undefined;
  autoFocus?: boolean | undefined;
  hideRequiredAsterix?: boolean | undefined;
  hideCopyButton?: boolean | undefined;
  valueDependsOn?: string | undefined;
  isConfidential?: boolean | undefined;
  isPicker?: boolean | undefined;
  order?: number | undefined;
  collapseIfDisabled?: boolean | undefined;
  visible?: boolean | undefined;
  errors?: IValidationErrors | undefined;
  dataType?: string | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  key: string;
  itemType: ContextualMenuItemType;
  split?: boolean | undefined;
  checked?: boolean | undefined;
  canCheck?: boolean | undefined;
  dependsOnSelection?: boolean | undefined;
  multiselect?: boolean | undefined;
  subMenuProps?: ICommandBarItem[] | undefined;
  disabledCategories?: string[] | undefined;
  separator?: boolean | undefined;
  isDefault?: boolean | undefined;
  overlayIcon?:
    | {
        iconName: string;
        position: string;
      }
    | undefined;
  onClick?: (
    ev?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
    item?: IContextualMenuItem
  ) => void;
}

export interface ISeparator {
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
}

export interface IBriefGridInfo {
  filter?: string | undefined;
  properties?: string[] | undefined;
  orderBy?: string | undefined;
  orderDirection?: string | undefined;
}

export interface IQuickFilterBar {
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  annotations?: IFormField[] | undefined;
  showSavedQueries?: boolean | undefined;
  favoritesEnabled?: boolean | undefined;
  previewQueryOnDemand?: boolean | undefined;
  typeInfoPath?: string | undefined;
  typeDetailsPath?: string | undefined;
  targetType?: string;
}

export interface IFilterBar {
  items: IUIItem[];
  layout?: ILayoutItem[] | undefined;
  childrenGap?: number | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  title: string;
}

export interface IAdvancedObjectPicker extends IScheme {}

export interface ISavedQueriesDescription {
  picker?: IObjectPicker | undefined;
  initialQueryId?: string | undefined;
  readOnly?: boolean | undefined;
}

export interface INav {
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  groups: INavLink[];
}

export interface IMessageCarousel {
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  url: string;
  itemTemplate?: IUIItem | undefined;
}

export interface IComponentStatus {
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  version?: string | undefined;
  lastChecked?: string | undefined;
  updateButton?: IUpdateButton | undefined;
  data?: any | undefined;
}

export interface IUpdateButton {
  title: string;
  updateAction: string;
}

interface AcknowledgmentConfig {
  acknowledgmentRequired: boolean;
  acknowledgmentText: string;
  text: string;
}

export interface ILoginScheme {
  items?: IUIItem[] | undefined;
  layout?: ILayoutItem[] | undefined;
  userRoles?: string[] | undefined;
  version?: number | undefined;
  stretch?: boolean | undefined;
  childrenGap?: number | undefined;
  justifyContent?: Align | undefined;
  valign?: boolean | undefined;
  border?: BorderType | undefined;
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  title?: string | undefined;
  background?: string | undefined;
  copyrightText?: string | undefined;
  passwordFlow?: IJsonForm | undefined;
  sso?: IOffice365Login[] | undefined;
  disclaimer?: AcknowledgmentConfig | undefined;
  extendedContent?: IScheme;
}

export interface IOffice365Login {
  title: string;
  image: string;
  scheme: string;
}

export interface ITheme {
  brandColors: IBrandColors;
  clientIcons: IClientIcons;
  colorMap: { [key: string]: { [key: string]: string } };
  iconMap: { [key: string]: { [key: string]: string } };
  elementStyles: IElementStyles;
  officePatelle?: any | undefined;
}

export interface IComponentStyle {
  padding?: string;
  "border-radius"?: string;
  "box-shadow"?: string;
  "margin-top"?: string;
  background?: string;
  "text-color"?: string;
}

export interface IContainerComponentStyle extends IComponentStyle {
  "item-text-color"?: string;
  "selected-item-text-color"?: string;
  "hover-item-background"?: string;
  "selected-item-background"?: string;
}

export interface IElementStyles {
  commandBar: IComponentStyle;
  gridWrapper: IComponentStyle;
  gridBodyWrapper: IComponentStyle;
  companyLogo: IComponentStyle;
  navBar?: IContainerComponentStyle;
  navHeader?: IContainerComponentStyle;
}

export interface IClientIcons {
  ok: string;
  success: string;
  errorBadge: string;
  error: string;
  high: string;
  incident: string;
  warning: string;
  edit: string;
  refresh: string;
  add: string;
  delete: string;
  forward: string;
  running: string;
  idle: string;
  disabled: string;
  unknown: string;
  cancelled: string;
  help: string;
  alert: string;
  informational: string;
  contact: string;
  logout: string;
  skipped: string;
  risk: string;
  externalLink: string;
}

export interface ITypeInfo {
  properties?: IPropertyInfo[] | undefined;
}

export interface IPropertyInfo {
  name?: string | undefined;
  allowedOperators?: ComparisonOperator[] | undefined;
  type?: string | undefined;
}

export interface IEula {
  type: string;
  id?: string | undefined;
  name?: string | undefined;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
}

export interface IWizard {
  title: string;
  closeConfirmationMessage: string;
  steps: IWizardStep[];
  auxActions?: IButton[];
  preInitActions?: IAjaxAction[];
}

export interface IWizardStep {
  items?: IUIItem[] | undefined;
  layout?: ILayoutItem[] | undefined;
  userRoles?: string[] | undefined;
  version?: number | undefined;
  stretch?: boolean | undefined;
  childrenGap?: number | undefined;
  justifyContent?: Align | undefined;
  valign?: boolean | undefined;
  border?: BorderType | undefined;
  type: string;
  id?: string | undefined;
  name: string;
  title: string;
  error?: string;
  fontSize?: FontSize | undefined;
  fontWeight?: FontWeight | undefined;
  bindings?: { [key: string]: string } | undefined;
  nextAction?: ISubmitButton | undefined;
  conditionalActions?: IConditionalAction[] | undefined;
}

export interface IConditionalAction {
  condition?: string | undefined;
  action?: string | undefined;
  ajaxAction?: IAjaxAction | undefined;
}

export enum TimeIntervalSelectionMode {
  Continious = "continious",
  Intermittent = "intermittent",
}

export interface IInplaceAvailabilitySchedule {
  serverTimeZone: string;
  label?: string | undefined;
  required?: boolean | undefined;
  name?: string | undefined;
  type?: string | undefined;
  selectionMode?: TimeIntervalSelectionMode;
  hidden?: boolean;
}

export type ActionContext = {
  selectedIds?: string[];
  selectedNames?: string[];
  independent?: boolean | null;
};

export interface ITab extends IScheme {
  items?: IScheme[];
}
